/**
 * Wrap window.location so that it's testable.
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	if (typeof window !== 'undefined') {
		return window.location;
	}
	return undefined;
};
